module.exports = __webpack_public_path__ + "static/media/icon-next.1b595493.svg";